import html2pdf from "html2pdf.js";
import { Printer } from "lucide-react";
import { useEffect, useState } from "react";
import Barcode from "react-barcode";
import { ApiCall } from "../CommonComponents/CustomHooks";

export default function LabelPrint() {
    const params = new URLSearchParams(window.location.search);
    const DocketNo = params.get("AWBNo");

    const [data, setData] = useState([]);

    const getData = async () => {
        const res = await ApiCall('/api/Shipment/PrintAwbNoLabel', {
            DocketNo: DocketNo || "",
        });
        if (res.status === "SUCCESS") {
            setData(res?.data);
        }
    };

    useEffect(() => {
        document.title = 'Label Print';
        getData();
    }, []);

    const donwloadPDF = () => {
        const element = document.getElementById("print-area");

        html2pdf()
            .from(element)
            .set({
                margin: 0,
                filename: `Label_${DocketNo}.pdf`,
                image: { type: "jpeg", quality: 1 },
                html2canvas: {
                    scale: 2,
                    useCORS: true,
                    scrollY: 0,
                    windowWidth: 800
                },
                jsPDF: {
                    unit: "mm",
                    format: [80, 100],
                    orientation: "portrait"
                },
                pagebreak: {
                    mode: ['css', 'legacy']
                }
            })
            .save();
    }

    const handlePrint = () => {
        window.print();
    };

    const styles = {
        controls: {
            display: "flex",
            gap: 10,
            padding: "12px 16px",
            background: "#f5f5f5",
            borderBottom: "1px solid #ddd",
            alignItems: "center",
        },

        btnBlue: {
            padding: "9px 22px",
            background: "#2c6a9b",
            color: "#fff",
            border: "none",
            borderRadius: 6,
            cursor: "pointer",
            fontSize: 14,
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            gap: 6,
        }
    };

    return (
        <div>
            {/* PRINT CSS */}
            <style>{`
                @media print {

                    body * {
                        visibility: hidden;
                    }

                    #print-area, #print-area * {
                        visibility: visible;
                    }

                    .page {
                       page-break-after: always;
                       break-after: page;
                    }

                    #print-area {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 210mm;
                    }
                    .page {
                        width: 210mm;
                        height: 260mm;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }

                    .label-content { 
                        transform: scale(2.4);
                        transform-origin: center;
                    }

                    @page {
                      size: A4 portrait;
                        margin: 0;
                    }
                }
            `}</style>

            {/* BUTTON */}
            <div className="no-print" style={styles.controls}>
                <button onClick={handlePrint} style={styles.btnBlue}>
                    <Printer size={16} /> Print
                </button>
            </div>

            {/* PRINT AREA */}
            <div id="print-area">
                {data?.map((item, index) => (
                    <div className="page" key={index}>

                        {/* LABEL */}
                        <table className="label" style={{
                            width: 700,
                            height: 400,
                            margin: "10px auto",
                            border: "2px solid #000",
                            fontFamily: "Arial",
                            fontSize: 13,
                            borderCollapse: "collapse",
                        }}>

                            <table style={{ width: "100%", borderCollapse: "collapse" }}>

                                {/* HEADER */}
                                <tr>
                                    <td style={{ padding: 5, width: "25%" }}>
                                        <img src="./assets/img/logo.jpg" style={{ height: 40 }} alt="" />
                                    </td>
                                    <td style={{ textAlign: "right", width: "50%", padding: 5 }}>
                                        <Barcode
                                            value={item.docketNo || ""}
                                            format="CODE128"
                                            width={1.5}
                                            height={40}
                                            displayValue={false}
                                            margin={0}
                                        />
                                    </td>
                                    <td colSpan="2" style={{
                                        width: "25%", textAlign: "right", padding: "5px",
                                        whiteSpace: "nowrap",
                                        fontWeight: "bold"
                                    }}>
                                        <b>{index + 1} OF {data.length}</b>
                                    </td>
                                </tr>

                                {/* COUNT */}
                                {/*<tr>*/}
                                {/*    <td colSpan="2" style={{ textAlign: "right", padding: "2px 3px" }}>*/}
                                {/*        {index + 1} OF {data.length}*/}
                                {/*    </td>*/}
                                {/*</tr>*/}

                                {/* DEST ROW */}
                                <tr style={{ borderTop: "1px solid #000" }}>
                                    <td style={{ padding: 5 }}>
                                        Destination Br.: <b>{item.toBranch}</b>
                                    </td>
                                    <td style={{ padding: 5 }}>
                                        Mode: <b>{item.mode} <i className={item.modeIcon}></i></b> &nbsp;&nbsp;
                                        Service: <b>{item.serviceType}</b>
                                    </td>
                                </tr>

                                {/* MAIN CONTENT */}
                                <tr style={{ borderTop: "1px solid #000" }}>
                                    {/* LEFT */}
                                    <td style={{ width: "65%", padding: 5, verticalAlign: "top" }}>
                                        <b>Consignee :</b> {item.consigneeName}
                                        <div>{item.address}</div>
                                        <div>{item.consigneePhoneEmail}</div>
                                    </td>

                                    {/* RIGHT */}
                                    <td style={{
                                        width: "35%",
                                        padding: 5,
                                        fontSize: 10,
                                        borderLeft: "1px solid #000",
                                        verticalAlign: "top"
                                    }}>
                                        <div><b>Booking Date:</b> {item.currentDate}</div>
                                        <div><b>Payment Type:</b> {item.paymentType}</div>
                                        <div><b>Packet Type:</b> {item.packetType}</div>
                                        <div><b>Weight:</b> {item.totalWeight}</div>
                                        <div><b>Volumetric:</b> {item.volumetricWeight}</div>
                                        <div><b>Charged:</b> {item.chargedWeight}</div>
                                        <div><b>Description:</b> {item.pcsDescription}</div>
                                        {item.shipmentType && <div><b>Shipment:</b> {item.shipmentType}</div>}
                                        {item.codAmount && <div><b>COD:</b> {item.codAmount}</div>}
                                    </td>
                                </tr>

                                {/* BARCODE */}
                                <tr style={{ borderTop: "1px solid #000" }}>
                                    <td colSpan="2" style={{ textAlign: "center", padding: 10 }}>
                                        <Barcode
                                            value={`${item.boxNo}`}
                                            format="CODE128"
                                            width={2}
                                            height={50}
                                            displayValue={true}
                                            fontSize={12}
                                            margin={0}
                                        />
                                    </td>
                                </tr>

                                {/* FOOTER */}
                                <tr style={{ borderTop: "1px solid #000", fontSize: 11 }}>
                                    <td style={{ padding: 5 }}>
                                        {item.returnAddress}
                                    </td>
                                    <td style={{ textAlign: "right", padding: 5 }}>
                                        {item.currentDateTime}
                                    </td>
                                </tr>

                            </table>
                        </table>

                    </div>
                ))}
            </div>
        </div>
    );
}